import { buttonStyles } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import {
  Icon,
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@festina-life/ui/structure'
import cx from 'classnames'
import { Fragment } from 'react'

import { FPlusScopeTabs } from './FPlusScopeTabs'

type FPlusScopePopoverProps = {
  path?: string
}

export const FPlusScopePopover = ({ path }: FPlusScopePopoverProps) => {
  const translate = useTranslate()

  return (
    <Popover className="flex-1">
      <PopoverButton
        className={cx(
          buttonStyles({
            variant: 'secondary',
            disabled: false,
            isFullWidth: true,
            isDanger: false,
          }),
          'focus:border-hidden flex-row justify-between!',
        )}
      >
        {translate('templateViewer.sidebar.modelDiagram.scope')}
        <Icon name="ChevronDown" className="ml-2 fill-primary" />
      </PopoverButton>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel
          unmount
          isShowingBackdrop
          className={cx(
            'fixed z-10 mt-2 rounded-lg',
            paperStyles({ isFaded: true, borders: ['all'] }),
          )}
        >
          <FPlusScopeTabs
            tabPanelClassName="max-w-[70vw] overflow-x-auto overflow-y-hidden"
            expressionPath={path}
          />
        </PopoverPanel>
      </Transition>
    </Popover>
  )
}
